const indexItems = [
  {
    title: '动作冒险',
    desc: '热血激战与极限追逐',
    count: '3,286部',
    icon: 'ri-sword-line',
    color: 'bg-primary-100 text-primary-700',
  },
  {
    title: '科幻奇幻',
    desc: '未来世界与异想空间',
    count: '1,852部',
    icon: 'ri-rocket-2-line',
    color: 'bg-accent-100 text-accent-800',
  },
  {
    title: '悬疑惊悚',
    desc: '烧脑剧情与心跳加速',
    count: '2,143部',
    icon: 'ri-search-eye-line',
    color: 'bg-secondary-100 text-secondary-700',
  },
  {
    title: '爱情文艺',
    desc: '浪漫故事与情感共鸣',
    count: '2,971部',
    icon: 'ri-heart-line',
    color: 'bg-primary-100 text-primary-700',
  },
  {
    title: '喜剧搞笑',
    desc: '欢乐时光与解压神器',
    count: '1,962部',
    icon: 'ri-emotion-laugh-line',
    color: 'bg-accent-100 text-accent-800',
  },
  {
    title: '纪录片',
    desc: '真实世界与深度探索',
    count: '1,534部',
    icon: 'ri-earth-line',
    color: 'bg-secondary-100 text-secondary-700',
  },
  {
    title: '动画动漫',
    desc: '二次元世界与经典IP',
    count: '2,418部',
    icon: 'ri-movie-2-line',
    color: 'bg-primary-100 text-primary-700',
  },
  {
    title: '电视剧集',
    desc: '热门剧集一网打尽',
    count: '5,672部',
    icon: 'ri-tv-2-line',
    color: 'bg-accent-100 text-accent-800',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 bg-background-50">
      <div className="section-container">
        <h2 className="font-display text-2xl md:text-3xl text-foreground-950 text-center mb-2">影视索引</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">按分类快速找到你想看的高清影视内容</p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="bg-background-100 rounded-lg p-4 md:p-5 hover:bg-background-200/70 transition-colors cursor-pointer group"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center mb-3 ${item.color}`}>
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1 whitespace-nowrap">{item.title}</h3>
              <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
              <span className="text-xs text-primary-600 font-medium whitespace-nowrap">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}